document.addEventListener('DOMContentLoaded', function() {
var url = window.location.pathname;

if (url.includes("verstellbar")) {
    document.querySelector('#bernstein_auswahl').value = "verstellbar";
} else {
    document.querySelector('#bernstein_auswahl').value = "";
}

if (url.includes("quaste")){
    document.querySelector('#quaste_auswahl').value = "quaste";
}
else
{
    document.querySelector('#quaste_auswahl').value="";
}
});



   

    document.addEventListener('input', function (event) {
        if (event.target.id !== 'bernstein_auswahl') 
            return;
        var dnd = document.querySelector('#bernstein_auswahl').value;
        console.log("auswahl " + dnd);
        if (dnd == "") {
            url = window.location.pathname;  
            window.location = url.replace('-verstellbar', '');
        } else {
            if (window.location.pathname.includes("-quaste")) {
                url = window.location.pathname.replace('-quaste', '');
                url = url + "-verstellbar-quaste";
            }
            else {
                url = window.location.pathname + "-verstellbar";
            }
            window.location = url;
        }
        console.log(dnd.value);
    }, false);



   
    document.addEventListener('input', function (event) {
        if (event.target.id !== 'quaste_auswahl') 
            return;
        var dnd = document.querySelector('#quaste_auswahl').value;
        console.log("auswahl "+dnd);
        if (dnd == ""){
            url = window.location.pathname;  
            window.location = url.replace('-quaste', '')
        }
        else
        {
            if (window.location.pathname.includes("-verstellbar")) {
                url = window.location.pathname.replace('-verstellbar', '');
                url = url + "-verstellbar-quaste";
            }
            else {
                url = window.location.pathname + "-quaste";
            }
            window.location = url;
        }
        console.log(dnd.value);
    }, false);


function func_test(){
    console.log("Test Funktion");
}